<template>
    <div id="r1s1">
        <h2 class="title main">
            {{ $t('f_r1s1_title') }}
        </h2>
        <!--<save-time></save-time>-->
        <compensation-banner />
        <br>
        <span class="under_title_orange"> {{ $t('f_r1s1_under_title') }} </span>
    

        <!-- <p>{{ $t('f_r1s1_subtitle') }}</p> -->
        <r1s1-flight-form />
    </div>
</template>

<script>
  import R1s1FlightForm from './R1s1FlightForm'
  import CompensationBanner from './CompensationBanner'

  export default {
    components: { R1s1FlightForm, CompensationBanner },
    inject: ['$validator']
  }
</script>

<style lang="scss">
  @import '~@stylesheets/_vars.scss';

  .under_title_orange {
      display: block;
      margin-bottom: 15px;
      color: $orange_new;
  }

</style>
